import React from "react";
import { ReactComponent as TickIcon } from "../../../assets/tick.svg";
import Button from "../../../component/common/Button";
import { useForm } from "react-hook-form";
import Checkbox from "../../../component/common/CheckBox"; // Correct usage of Checkbox

const EventSurvey = () => {
  const { register, handleSubmit } = useForm();

  // Define the onSubmit method
  const onSubmit = (data) => {
    console.log("Selected Data: ", data);
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="bg-white overflow-x-hidden w-full min-h-[948px] my-[16px] rounded-[10px] relative "
    >
      <img src="/survey-img.png" alt="" className="w-full " />

      <div className="w-[95%] mx-auto md:w-[600px] xl:w-[769px] rounded-[10px] bg-white shadow-survey-card-shadow xs:p-[16px] p-[10px] static xl:absolute top-1/2 translate-y-0 xl:translate-y-[-50%] sm:min-h-[706px] left-1/2 mt-[-40px] xs:mt-[-80px] sm:mt-[-100px] xl:mt-0 translate-x-0 xl:translate-x-[-50%]">
        <div className="flex gap-[16px] items-center xl:!flex-nowrap flex-wrap">
          <img
            src="/event1.png"
            alt=""
            className="h-[180px] w-full sm:h-[250px] xl:h-[144px] xl:w-[256px] object-cover rounded-[14px]"
          />
          <div>
            <h1 className="text-[22px] xs:text-[26px] text-dark-blue font-semibold mb-[6px]">
              Post event survey form
            </h1>
            <p className="text-[#626570] xs:text-base text-sm">
              Typically, these question types yield valuable feedback about the
              event’s presentations, location, and even the food.
            </p>
          </div>
        </div>

        <div className="mt-[16px] pt-[20px] border-t border-t-[#C1CAE1]">
          <h1 className="text-[#06152B] text-lg xs:text-xl font-medium mb-[10px]">
            How satisfied were you with the event? 
          </h1>
          {[
            "Very Satisfied",
            "Satisfactory",
            "Average",
            "Somewhat satisfied",
            "Unsatisfied",
          ].map((label, index) => (
            <div
              className="flex space-x-[6px] mt-[10px] items-center"
              key={index}
            >
              <div className="relative h-4 w-4">
                <input
                  type="checkbox"
                  {...register(`satisfaction-${index}`)}
                  className="absolute w-full h-full cursor-pointer rounded-md border-blue-color border-[1px] focus:ring-0 appearance-none peer"
                  id={`satisfaction-${index}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2E3E8D] to-[#4DB1E1] rounded-md hidden peer-checked:block transition-opacity duration-200 pointer-events-none"></div>
                <TickIcon className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 hidden peer-checked:block transition-opacity duration-200 pointer-events-none" />
              </div>
              <label
                className="font-light text-sm text-[#030229] cursor-pointer"
                htmlFor={`satisfaction-${index}`}
              >
                {label}
              </label>
            </div>
          ))}
        </div>

        <div className="mt-[20px] pt-[20px] border-t border-t-[#C1CAE1]">
          <h1 className="text-[#06152B] text-lg xs:text-xl font-medium mb-[10px]">
            What did you like most about the event? 
          </h1>
          <div className="flex  space-x-8">
            {["Food", "Venue", "Speakers", "Customer service"].map(
              (item, index) => (
                <div
                  className="flex  space-x-[6px] mt-[10px] items-center"
                  key={index}
                >
                  <div className="relative h-4 w-4">
                    {/* Updated to use the Checkbox component */}
                    {/* <Checkbox
                      {...register(`liked-${index}`)}
                      defaultChecked={false}
                      id={`liked-${index}`}
                    /> */}
                    <input
                      type="checkbox"
                      {...register(`eventSatisfaction-${index}`)}
                      className="absolute w-full h-full cursor-pointer rounded-md border-blue-color border-[1px] focus:ring-0 appearance-none peer"
                      id={`eventSatisfaction-${index}`}
                    />
                    <TickIcon className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 hidden peer-checked:block transition-opacity duration-200 pointer-events-none" />
                  </div>
                  <label
                    className="font-light text-sm text-[#030229] cursor-pointer"
                    htmlFor={`liked-${index}`}
                  >
                    {item}
                  </label>
                </div>
              )
            )}
          </div>
        </div>

        <div className="w-full flex mt-[20px] pt-[20px] mb-[16px] border-t border-t-[#C1CAE1] justify-center items-center">
          <Button type="submit" content="Submit" />
        </div>
      </div>
    </form>
  );
};

export default EventSurvey;
